<template>

  <svg
    t="1639130872871"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4135"
    width="64"
    height="64"
  ><path d="M651.14133333 413.01333333l-56.344 56.344C542.30933333 470.45333333 489.82133333 505.23733333 437.33333333 573.73333333a416 416 0 0 0 26.48 26.6l-49.976 49.984c-24.168-19.76-48.336-43.416-72.504-70.984C426.66933333 463.33333333 511.99733333 405.33333333 597.33333333 405.33333333c17.936 0 35.872 2.56 53.808 7.68z m113.968 67.056c29.408 26.2 58.816 59.28 88.224 99.264C767.99733333 676.66933333 682.66933333 725.33333333 597.33333333 725.33333333c-22.456 0-44.92-3.368-67.376-10.112l54.456-54.456c4.304 0.376 8.616 0.568 12.92 0.568 53.336 0 106.664-29.2 160-87.6-13.368-17.44-26.736-32.704-40.112-45.784l47.888-47.88zM213.33333333 213.33333333V85.33333333h64v128h640v64H277.33333333v640h-64V277.33333333H85.33333333v-64h128z" p-id="4136" /><path d="M770.34933333 339.06133333l45.256 45.256-407.288 407.288-45.256-45.256z" p-id="4137" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconLineHide',
} as DefineComponent
</script>